'use client';

import { Dialog, ButtonGroup, Button, Flex, Text, Input } from '@/_components';
import { FC, useContext, useEffect, useRef } from 'react';
import { LayoutContext } from '@/_contexts/LayoutProvider';
import type { CopyTextDialogProps } from './CopyTextDialog.types';

export const CopyTextDialog: FC<CopyTextDialogProps> = () => {
  const { textToCopy, setTextToCopy } = useContext(LayoutContext);
  const inputRef = useRef<HTMLInputElement>(null);

  const onClose = () => {
    setTextToCopy(undefined);
  };

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.select();
    }
  }, [textToCopy]);

  if (!textToCopy) return null;

  return (
    <Dialog isOpen={!!textToCopy} onClose={onClose}>
      <Dialog.Content>
        <Flex isColumn={true} gap={4}>
          <Text type="small" color="secondary">
            Copy to clipboard: <kbd>⌘CMD</kbd> + <kbd>C</kbd>
          </Text>
          <Input
            ref={inputRef}
            label="Text to copy"
            isLabelHidden={true}
            onChange={() => null}
            autoFocus={true}
            value={textToCopy}
          />
        </Flex>
      </Dialog.Content>
      <Dialog.Footer>
        <ButtonGroup align="right">
          <Button intent="secondary" value="Close" onClick={onClose} />
        </ButtonGroup>
      </Dialog.Footer>
    </Dialog>
  );
};
